import React from 'react';
import { Typography, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { AdvertEntity } from '../../../../domain';
import AdvertInfo from '../../AdvertInfo/AdvertInfo.component';

export interface ReviewStepProps {
  advertModel: AdvertEntity;
  checkedChannels: Record<string, boolean>;
}

const ReviewStep: React.FC<ReviewStepProps> = ({
  advertModel,
  checkedChannels,
}) => {
  const { t } = useTranslation();

  const selectedChannelsCount = checkedChannels 
    ? Object.keys(checkedChannels).filter((key) => checkedChannels[key]).length 
    : 0;

  return (
    <Flex vertical style={{ width: '100%' }} gap="middle">
      <Typography.Title level={4} style={{ textAlign: 'center', width: '100%' }}>
        {t('advert-final-check', { ns: 'labels' })}
      </Typography.Title>
      <AdvertInfo advertModel={advertModel} />
      <div style={{paddingInlineStart: '20px'}}>
        <Typography.Title level={5}>{t('advert-selected-channels', { ns: 'labels' })}:</Typography.Title>
        <Typography.Paragraph>{selectedChannelsCount}</Typography.Paragraph>
      </div>
      <div style={{paddingInlineStart: '20px'}}>
        <Typography.Title level={5}>{t('advert-files-count', { ns: 'labels' })}:</Typography.Title>
  <Typography.Paragraph>{advertModel.attachments.length}</Typography.Paragraph>
      </div>
    </Flex>
  );
};

export default ReviewStep;